<template>
	<v-container class="pt-5">
		<v-layout row wrap>
			<v-flex xs12 sm6 order-xs1 order-sm1 class="top-section-left">
				<span class="headline font-weight-bold grey--text">{{ heading }}</span>
					<span v-if="subheading" class="details grey--text">{{ subheading }}</span>
			</v-flex>
			<v-flex xs12 sm6 order-xs2 order-sm2 class="right top-section-right">
				<div class="right">
					<div v-if="!hideSearch" class="data-table-search">
						<v-icon>search</v-icon>
						<input
							type="text"
							v-bind:value="value"
							:placeholder="`Search ${searchLabel}`"
							v-on:input="updateValue($event.target.value)"
							class="pl-4"
							/>
					</div>
				</div>
			</v-flex>

		</v-layout>
	</v-container>
</template>

<script>

  export default {
		name: 'TopSection',
		props: {
			heading: String,
			subheading: String,
			user: String,
			searchLabel: String,
			searchValue: String,
			searchValue: String,
			value: String,
			hideSearch: Boolean
		},
		methods: {
			updateValue: function (value) {
				this.$emit('input', value);
			}
		}
  }

</script>

<style lang="scss">
	.top-section-spacing {
		.top-section-left {
			@media (min-width: 600px) {
				padding-left: 20px;
			}
		}
	}
	.logout-button {
		transform: rotate(180deg);
	}
	.user-prev {
		width: 52px;
		height: 52px;
		line-height: 52px !important;
		border-radius: 50%;
		display: inline-block;
		background-color: #FFFFFF;
		text-align: center;
	}
	.logout-button, .user-prev {
		vertical-align: middle;
	}
	.top-section-left {
		.details {
			display: block;
			font-size: 18px;
			margin-top: 10px;
		}
		display: flex;
		flex-flow: column;
	}
	.data-table-search {
		width: 362px;
		padding-left: 8px;
		padding-bottom: 9px;
		border-bottom: 1px solid #373B47;
		@media (max-width: 959px) {
			width: 100%;
		}
		input, i {
			vertical-align: middle;
			color: #373B47 !important;
		}
		input {
			outline: none;
			width: calc(100% - 24px);
			::-webkit-input-placeholder {
                font-style: italic !important;
				color: #373B47 !important;
            }
            ::-moz-placeholder {
                font-style: italic !important;
				color: #373B47 !important;
            }
            :-ms-input-placeholder {
                font-style: italic !important;
				color: #373B47 !important;
            }
            :-moz-placeholder {
                font-style: italic !important;
				color: #373B47 !important;
            }
		}
		.v-text-field__slot, label.v-label {
			padding-left: 48px !important;
		}
		.v-input__prepend-outer {
			margin-right: -30px;
		}
		&.v-input--is-focused {
			.v-icon {
				color: #000 !important;
			}
		}
	}
	.top-section-right {
		& > div {
			@media (max-width: 959px) {
				float: none !important;
			}
			@media (max-width: 599px) {
				padding-top: 24px;
			}
		}
	}
</style>
